<template>
  <div class="line-ctn" @click="clickHandler">
    <div class="menu-item-left">
      <i :class="icon" class="menu-item-left-icon" />
      <slot></slot>
    </div>
    <div class="menu-item-right">
      <span>{{shortcut}}</span>
      <span v-show="arrow" class="el-icon-arrow-right menu-item-right-icon"></span>
    </div>
  </div>
</template>

<script>

export default {
  name: "mainMenuLine",
  props: ["icon", "shortcut", "arrow"],
  methods: {
    clickHandler: function(arg) {
      this.$emit("click", arg)
    },
  },
}
</script>

<style scoped>
.line-ctn {
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 3em;
  user-select: none;
}
.line-ctn:hover {
  color: white;
  background: #333333;
}
.line-ctn:active {
  background: #111111;
}
.menu-item-left {
  padding-left: 12px;
}
.menu-item-right {
  padding-right: 12px;
}
.menu-item-left-icon {
  padding-right: 0.5em;
}
.menu-item-right-icon {
  padding-left: 0.5em;
  
}
</style>